import { h, render, Component } from 'preact';
import Utils from '../../utils';
import { Context, ContextUtil } from '../context';
import { replaceParameters, insertCustomComponents } from './common';
import CiblerAPI from '../ciblerApi';

export default class CommonBlock extends Component {
  constructor(props) {
    super(props);

    const autoCloseTimeout = Utils.getCampaignData(props.autoCloseTimeout, 0);
    if (autoCloseTimeout) {
      setTimeout(() => { this.closeBlock(); }, autoCloseTimeout);
    }

    this.buttonType = Utils.getCampaignData(this.props.acceptButtonType, 'copy').toLowerCase();
    this.nobutton = this.buttonType === 'nobutton';
    this.exitUrl = Utils.getCampaignData(this.props.exitUrl);
    this.notifBell = false;

    this.state = {
      content: '',
      closed: !!(localStorage.getItem('currentClosed') || '').includes(this.props.campaignId),
      hidden: !!(localStorage.getItem('currentClosed') || '').includes(this.props.campaignId),
    };

    if (Utils.getCampaignData(this.props.customCSS)) {
      var element = document.createElement('style');
      element.innerHTML = Utils.getCampaignData(this.props.customCSS)
      document.head.appendChild(element);
    }
  }

  componentDidMount() {
    const content = this.renderContent();

    if (content) {
      this.setState({
        content,
      }, () => {
        this.bindButtons();
        if (Utils.getCampaignData(this.props.customJS)) {
          try {
            eval(Utils.getCampaignData(this.props.customJS));
          } catch (e) {
            console.log('CustomJS error: ', {e});
          }
        }
      });
    }
  }

  componentDidUpdate() {
    insertCustomComponents(this.props);
    this.bindButtons();
  }

  getAcceptBtnStyle = () => {
    const acceptStyle = {
      border: 'none',
      bottom: '10%',
      right: 0,
      position: 'absolute',
      fontSize: '1.2em',
      padding: '5px',
      left: 0,
      margin: 'auto',
      textAlign: 'center',
      width: '100px',
    };

    if (Utils.getCampaignData(this.props.acceptButtonColor)) acceptStyle.background = this.props.acceptButtonColor.value;
    if (Utils.getCampaignData(this.props.acceptButtonFontColor)) acceptStyle.color = this.props.acceptButtonFontColor.value;
    if (Utils.getCampaignData(this.props.acceptButtonfontFamily)) acceptStyle.fontFamily = this.props.acceptButtonfontFamily.value;
    if (Utils.getCampaignData(this.props.acceptButtonWidth)) acceptStyle.width = this.props.acceptButtonWidth.value;
    if (Utils.getCampaignData(this.props.acceptButtonHeight)) acceptStyle.height = this.props.acceptButtonHeight.value;

    return acceptStyle;
  };

  getStyle = () => {
    const style = {
      padding: '0',
      backgroundSize: 'cover',
      transition: 'opacity linear 500ms',
      opacity: this.state.closed ? 0 : 1,
    };
    if (Utils.getCampaignData(this.props.backgroundImg)) style.backgroundImage = `url('${Context.clientUrl}campaigns/assets/${this.props.campaignId}/${Context.device}${Utils.getCampaignData(this.props.backgroundImg)}')`;
    if (Utils.getCampaignData(this.props.height)) style.maxHeight = Utils.getCampaignData(this.props.height);
    if (Utils.getCampaignData(this.props.textColor)) style.color = Utils.getCampaignData(this.props.textColor);
    if (Utils.getCampaignData(this.props.exitUrl)) style.cursor = 'pointer';
    if (Utils.getCampaignData(this.props.display)) style.display= Utils.getCampaignData(this.props.display);
    if (Context.device === 'desktop') style.minWidth = '300px';
    const styleKey = ['backgroundColor', 'fontFamily', 'width', 'top', 'left', 'bottom', 'right', 'borderRadius'];
    styleKey.forEach((key) => {
      if (Utils.getCampaignData(this.props[key])) style[key] = Utils.getCampaignData(this.props[key]);
    });

    if (this.state.hidden) style.display = 'none';

    return style;
  };

  getExitStyle = () => {
    const exitStyle = {
      background: 'none', border: 'none', top: '0', right: '0', position: 'absolute', margin: '5px',
    };
    if (Utils.getCampaignData(this.props.exitButtonColor)) exitStyle.background = this.props.exitButtonColor.value;
    if (Utils.getCampaignData(this.props.exitButtonFontColor)) exitStyle.color = this.props.exitButtonFontColor.value;
    if (Utils.getCampaignData(this.props.fontFamily)) exitStyle.fontFamily = this.props.fontFamily.value;
    if (Utils.getCampaignData(this.props.exitButtonTop)) exitStyle.top = this.props.exitButtonTop.value;
    if (Utils.getCampaignData(this.props.exitButtonRight)) exitStyle.right = this.props.exitButtonRight.value;
    if (Utils.getCampaignData(this.props.display)) exitStyle.display = Utils.getCampaignData(this.props.display);

    return exitStyle;
  };

  notifStyle = () => ({
    transition: 'opacity linear 500ms',
    left: '50px',
    bottom: '50px',
    right: 'initial',
    top: 'initial',
    height: '100px',
    width: '100px',
    position: 'fixed',
    zIndex: 10000000,
    background: `url('${Context.clientUrl}static/${Context.customerId}/${Context.device}/bell.png') center / contain no-repeat`,
    border: 'none',
    opacity: this.state.closed ? 1 : 0,
    display: this.state.closed ? 'block' : 'none',
  });

  completeGift = (baseContent, disableAutoCopy) => (stringParams) => {
    const params = JSON.parse(stringParams);
    localStorage.setItem('ciblerPreviousCode', params.code);
    let content = baseContent || '';
    content = content.replace('{{firstName}}', Context.customer.first_name);
    content = content.replace('{{giftCode}}', `<ciblerCodeTag id="ciblerCode">${params.code}</ciblerCodeTag>`);
    ContextUtil.update([this.props.campaignId, 'code'], params.code);
    ContextUtil.update([this.props.campaignId, 'codename'], params.gift.name);
    content = content.replace('{{giftName}}', params.gift.name);
    content = content.replace('{{giftThreshold}}', params.gift.threshold);
    const priceReg = /(\d+)\.(\d+)€/g;
    if (priceReg.test(params.gift.description)) {
      content = content.replace('{{giftDescription}}',
        params.gift.description.replace(priceReg, (cor, p1, p2) => `${p1},${p2.length > 1 ? p2 : `${p2}0`}€`));
    } else {
      content = content.replace('{{giftDescription}}', params.gift.description);
    }

    content = Utils.tryFunction(replaceParameters, [content, this.props]);
    this.setState({ content, showGift: true, giftCode: params.code });
    const body = document.getElementById(`WioGameBG_${this.props.campaignId}`);
    setTimeout(() => {
      if (Utils.getCampaignData(this.props.autoCopyTimer, 0) && !disableAutoCopy) {
        setTimeout(() => this.handleAccept(), Utils.getCampaignData(this.props.autoCopyTimer, 0));
      }

      const codeBlock = body.querySelector('#wioBlockCode');
      if (codeBlock) {
        codeBlock.style.display = '';
        codeBlock.value = params.code;
      }

      const discovered = localStorage.getItem('cib_discovered');
      if (discovered) {
        if (!discovered.includes(this.props.campaignId)) {
          localStorage.setItem('cib_discovered', `${discovered};${this.props.campaignId}`);
        }
      } else {
        localStorage.setItem('cib_discovered', this.props.campaignId);
      }
    }, 100);
  };

  renderContent = () => {
    if (Utils.getCampaignData(this.props.hiddenGift, false)
      && (!(localStorage.getItem('cib_discovered')
        && localStorage.getItem('cib_discovered').includes(this.props.campaignId))
        || Context.trigger)) {
      let content = Utils.getCampaignData(this.props.hiddenGiftContent, '');
      content = content.replace('{{firstName}}', Context.customer.first_name);
      content = content.replace('{{giftDescription}}', Context[this.props.campaignId].giftDescription);

      return Utils.tryFunction(replaceParameters, [content, this.props]);
    }

    if (!Context[this.props.campaignId].prizeUUID && !Context.trigger) {
      this.completeGift(this.props.content?.value, true)(JSON.stringify({ code: null, gift: {} }));
      return null;
    }

    Utils.tryFunction(
      CiblerAPI.discoverGift,
      [Context[this.props.campaignId], this.completeGift(this.props.content?.value, true)],
    );
    return null;
  };

  renderSimpleContent = (props) => {
    const content = Utils.getCampaignData(props.content, '');
    return replaceParameters(content, props);
  };

  bindButtons = () => {
    const body = document.getElementById(`WioGameBG_${this.props.campaignId}`);
    const contentBlock = body.querySelector('#wioContent');
    if (!contentBlock) return;

    const crossSellButton = contentBlock.getElementsByClassName('wioBlockCrossSell');
    if (crossSellButton.length) {
      crossSellButton[0].onclick = (e) => {
        if (Utils.getCampaignData(this.props.exitUrl)) {
          e.preventDefault();
          e.stopPropagation();
        }

        const context = Context[this.props.campaignId];

        window.WIO.track('discoverBlock', this.props.campaignId, context.sessionId);
        CiblerAPI.discoverGift(context, (result) => {
          const params = JSON.parse(result);
          this.props.crossSellCustomAction(
            context.crossSell.id,
            params.code,
            () => { this.completeGift(this.props.content?.value)(result); }
          );
        });
        return false;
      };

      return;
    }

    if (!this.state.showGift && !this.insertDiscoverButton()) {
      let button = contentBlock.getElementsByTagName('button');
      if (!button.length) {
        button = contentBlock.getElementsByClassName('wioBlockDiscover');
      }
      button[0].addEventListener('click', this.handleDiscover, {
        passive: false,
        capture: true,
      });
      return;
    }

    if (!this.insertAcceptButton() && !this.nobutton) {
      let button = contentBlock.getElementsByTagName('button');
      if (!button.length) {
        button = contentBlock.getElementsByClassName('wioBlockAccept');
      }
      if(button.length){
      button[0].addEventListener('click', this.handleAccept, {
        passive: false,
        capture: true,
      });
      }
    }
  };

  handleDiscover = (e) => {
    if (Utils.getCampaignData(this.props.exitUrl)) {
      e.preventDefault();
      e.stopPropagation();
    }
    window.WIO.track('discoverBlock', this.props.campaignId, Context[this.props.campaignId].sessionId);
    CiblerAPI.discoverGift(Context[this.props.campaignId], this.completeGift(this.props.content?.value));
    return false;
  };

  handleAccept = (e, acceptOverride) => {
    if (this.nobutton) return;

    window.WIO.track('acceptBlock', this.props.campaignId, Context[this.props.campaignId].sessionId);
    if (this.buttonType.includes('copy')) acceptOverride ? acceptOverride(e) : this.props.acceptBlock(e, true);

    if (this.buttonType.includes('close')) this.closeBlock(e);

    if (this.buttonType.includes('exit')) {
      window.location.href = this.exitUrl;
    }

    if (Utils.getCampaignData(this.props.exitOnAccept, false)) {
      this.closeBlock(e);
    }
  };

  closeBlock = (e) => {
    if (e) e.stopPropagation();
    if (!Utils.getCampaignData(this.props.notifBell, false)) return this.props.refuseBlock();

    localStorage.setItem('currentClosed',
      `${localStorage.getItem('currentClosed') || ''}|${this.props.campaignId}`);

    this.setState({ closed: true }, () => {
      setTimeout(() => this.setState({ hidden: true }), 500);
    });

    return false;
  };

  openBlock = (remote) => () => {
    if (!remote) {
      localStorage.removeItem('currentClosed');
      Object.values(window.WIORENDER.openFunctions)
        .forEach(f => f());
      window.WIORENDER.openFunctions = {};
      window.WIORENDER.secureOpenFunctions = {};
    }

    this.setState(
      { hidden: false },
      () => setTimeout(
        () => this.setState({ closed: false }),
        50,
      ),
    );
  };

  insertDiscoverButton = () => {
    if (this.state.showGift) return null;
    if (this.state.content.includes('<button') || this.state.content.includes('wioBlockDiscover')) return null;

    const acceptStyle = this.getAcceptBtnStyle();

    return (<button
      style={acceptStyle}
      onClick={this.handleDiscover}
    >
      {Utils.getCampaignData(this.props.discoverButtonText, `Je découvre mon code`)}
    </button>);
  };

  insertAcceptButton = () => {
    if (!this.state.showGift || this.nobutton) return null;

    if (this.state.content.includes('<button') || this.state.content.includes('wioBlockAccept')) return null;

    const acceptStyle = this.getAcceptBtnStyle();

    return (<button
      style={acceptStyle}
      onClick={this.handleAccept}
    >
      {Utils.getCampaignData(this.props.acceptButtonText, `J'en profite`)}
    </button>);
  };

  insertBellButton = () => {
    if (!Utils.getCampaignData(this.props.notifBell, false)) return null;
    if (!this.state.closed) return null;
    if (document.getElementById('wioNotifMini')
      || (document.getElementById('wioNotif') && !this.notifBell)) {
      window.WIORENDER.openFunctions[this.props.campaignId] = this.openBlock(true);
      this.notifBell = false;
      return null;
    }
    window.WIORENDER.secureOpenFunctions[this.props.campaignId] = this.openBlock(true);
    this.notifBell = true;

    const style = this.notifStyle();
    if (Utils.getCampaignData(this.props.bellLeft, '')) style.left = Utils.getCampaignData(this.props.bellLeft, '');
    if (Utils.getCampaignData(this.props.bellBottom, '')) style.bottom = Utils.getCampaignData(this.props.bellBottom, '');
    if (Utils.getCampaignData(this.props.bellTop, '')) style.top = Utils.getCampaignData(this.props.bellTop, '');
    if (Utils.getCampaignData(this.props.bellRight, '')) style.right = Utils.getCampaignData(this.props.bellRight, '');
    if (Utils.getCampaignData(this.props.bellSize, '')) {
      style.height = Utils.getCampaignData(this.props.bellSize, '');
      style.width = Utils.getCampaignData(this.props.bellSize, '');
    }

    return <button
      id="wioNotif"
      style={style}
      onClick={this.openBlock(false)}
    />;
  };

  render() {
    return <div/>;
  };
};
